<template>
  <div class="app-container bj-label-colon">
    <el-form ref="form" :model="form" :rules="rules" label-width="500px">
      <BjDivider right-fixed>{{ $t('StockRules.Header.title') }}
        <template slot="right">
          <el-button @click="handleClose">{{ $t('cancelText') }}</el-button>
          <el-button v-permission:SettingStockRulesConfig_Save @click="resetForm('form')">{{ $t('resetText') }}</el-button>
          <el-button v-permission:SettingStockRulesConfig_Save type="primary" @click="handleConfirm('form')">{{ $t('saveText') }}</el-button>
        </template>
      </BjDivider>

      <el-form-item :label="$t('StockRules.Header.method')" prop="radixPointComputeMode">
        <BjRadioLov v-model="form.radixPointComputeMode" :option-list="RADIX_POINT_COMPUTED_MODE_LIST">
          <template #default="{ item }">
            {{ $t(item.label) }}
            <el-tooltip effect="dark" placement="top-start" :content="
                item.value === 'trunc'
                  ? $t('StockRules.Header.down')
                  : $t('StockRules.Header.up')
              ">
              <i class="el-icon-question"></i>
            </el-tooltip>
          </template>
        </BjRadioLov>
      </el-form-item>

      <el-form-item :label="$t('StockRules.Header.shortage')" prop="backordersPriorityStatus">
        <el-switch v-model="form.backordersPriorityStatus" />

        <el-button v-if="form.backordersPriorityStatus" type="text" class="ml10" @click="
            $refs.ChannelSort.show(backordersChannelPriorityArray, 'backordersChannelPriorityArray')
          ">{{ $t('StockRules.Header.channel') }}</el-button>
      </el-form-item>

      <el-form-item v-if="form.backordersPriorityStatus" :label="$t('StockRules.Header.rule')" prop="backordersPriorityRule">
        <el-radio-group v-model="form.backordersPriorityRule">
          <div style="margin-top: 8px">
            <el-radio :label="true">{{ $t('StockRules.Header.delivery') }} </el-radio>
          </div>
          <div style="margin-top: 8px">
            <el-radio :label="false">{{ $t('StockRules.Header.quantity') }}
              <!--  false从近到远 true从远到近 -->
              <el-radio-group v-show="form.backordersPriorityRule == false" v-model="form.backordersNumberRule" style="margin-left: 8px">
                <el-radio :label="1">{{ $t('StockRules.Header.quan') }}</el-radio>
                <el-radio :label="2">{{ $t('StockRules.Header.tity') }}</el-radio>
              </el-radio-group>
            </el-radio>
          </div>
        </el-radio-group>
      </el-form-item>

      <BjDivider>{{ $t('StockRules.Main.title') }}</BjDivider>

      <!-- TODO: 弹窗设置 -->
      <el-form-item :label="$t('StockRules.Main.Channel')" prop="channelPriority">
        <el-button type="text" class="ml10" @click="$refs.ChannelSort.show(channelPriorityArray, 'channelPriorityArray')">{{ $t('settingText') }}</el-button>
      </el-form-item>

      <el-form-item :label="$t('StockRules.Main.Virtual')" prop="virtualReplenishPriorityRule">
        <el-link type="warning" :underline="false">{{ $t('StockRules.Main.Drag') }}</el-link>
        <div id="virtualReplenishPriorityRule">
          <div v-for="e in STOCK_WAREHOUSE_TYPE_SON_1_LIST_VIRTUAL" :key="e.value" class="sort-item virtualReplenishPriorityRule">
            {{ $t(e.label) }}
            <svg-icon icon-class="pointer" class="virtualReplenishPriorityRule-handle" />
          </div>
        </div>
      </el-form-item>

      <!--  0按可用库存从少到多 1按创建时间 2按仓位  -->
      <el-form-item :label="$t('StockRules.Main.rule')" prop="sameVirtualReplenishPriorityRule">
        <el-radio-group v-model="form.sameVirtualReplenishPriorityRule">
          <div style="margin-top: 8px">
            <el-radio :label="0">{{ $t('StockRules.Main.less') }} </el-radio>
          </div>
          <div style="margin-top: 8px">
            <el-radio :label="1">{{ $t('StockRules.Main.creation') }}
              <!--  false从近到远 true从远到近 -->
              <el-radio-group v-show="form.sameVirtualReplenishPriorityRule == 1" v-model="form.virtualDateSort" style="margin-left: 8px">
                <el-radio :label="false">{{ $t('StockRules.Main.near') }}</el-radio>
                <el-radio :label="true">{{ $t('StockRules.Main.far') }}</el-radio>
              </el-radio-group>
            </el-radio>
          </div>
          <div style="margin-top: 8px">
            <el-radio :label="2">{{ $t('StockRules.Main.warehouse') }}

              <el-radio-group v-show="form.sameVirtualReplenishPriorityRule == 2" v-model="form.virtualSpaceSort" style="margin-left: 8px">
                <el-radio :label="false">{{ $t('StockRules.Main.high') }}</el-radio>
                <el-radio :label="true">{{ $t('StockRules.Main.low') }}</el-radio>
              </el-radio-group>
            </el-radio>
          </div>
        </el-radio-group>
      </el-form-item>

      <BjDivider>{{ $t('StockRules.Bottom.title') }}</BjDivider>

      <el-form-item :label="$t('StockRules.Bottom.Inventory')" prop="stockDeductionPriorityRule">
        <el-link type="warning" :underline="false">{{ $t('StockRules.Bottom.Drag') }}</el-link>
        <div id="stockDeductionPriorityRule">
          <div v-for="e in STOCK_WAREHOUSE_TYPE_SON_1_LIST_STOCK" :key="e.value" class="sort-item stockDeductionPriorityRule">
            {{ $t(e.label) }}
            <svg-icon icon-class="pointer" class="stockDeductionPriorityRule-handle" />
          </div>
        </div>
      </el-form-item>

      <!--  1时间 0按可用库存从多到少   -->
      <el-form-item :label="$t('StockRules.Bottom.rules')" prop="subVirtualReplenishPriorityRule">
        <el-radio-group v-model="form.subVirtualReplenishPriorityRule">
          <div style="margin-top: 8px">
            <el-radio :label="1">{{ $t('StockRules.Bottom.creation') }}
              <!--  false从近到远 true从远到近 -->
              <el-radio-group v-show="form.subVirtualReplenishPriorityRule == 1" v-model="form.subVirtualDateSort" style="margin-left: 8px">
                <el-radio :label="false">{{ $t('StockRules.Bottom.near') }}</el-radio>
                <el-radio :label="true">{{ $t('StockRules.Bottom.far') }}</el-radio>
              </el-radio-group>
            </el-radio>
          </div>
        </el-radio-group>
      </el-form-item>

      <BjDivider>{{ $t('StockRules.Footer.title') }}</BjDivider>

      <el-form-item label="" prop="inventoryOversoldRatio">
        {{ $t('StockRules.Footer.total') }}
        <el-input-number v-model="form.inventoryOversoldRatio" :min="100" :max="500" :precision="0" :controls="false" /> %
        <p class="tips">{{ $t('StockRules.Footer.The') }}</p>
      </el-form-item>
    </el-form>
    <ChannelSort ref="ChannelSort" @confirm="handleChannelSortConfirm" />
  </div>
</template>
<script>
import viewMiXin from '@/utils/view-mixin.js';
import Sortable from 'sortablejs';
import { stockApi } from '@/api';
import { RADIX_POINT_COMPUTED_MODE_LIST, STOCK_WAREHOUSE_TYPE_SON_1_LIST } from '@/utils/constants';
import ChannelSort from './components/ChannelSort.vue';
const getDefaultForm = () => {
  return {
    id: null,
    tenantId: null,
    // 审核
    allotAudit: true,
    transferAudit: true,
    stockReservedAudit: true,
    branchWarehouseAudit: true,
    // 规则
    radixPointComputeMode: 'trunc',
    backordersPriorityStatus: true,
    backordersPriorityRule: true,
    backordersNumberRule: 1,
    backordersChannelPriority: '[]',
    channelPriority: '[]',
    virtualReplenishPriorityRule: 'interline-virtual,qty-virtual,ratio-virtual',
    sameVirtualReplenishPriorityRule: 0,
    virtualDateSort: true,
    virtualSpaceSort: true,
    stockDeductionPriorityRule: 'interline-virtual,qty-virtual,ratio-virtual',
    subVirtualReplenishPriorityRule: 1,
    subVirtualDateSort: true,
    inventoryOversoldRatio: 100,
  };
};
export default {
  name: 'SettingStockRulesConfig',
  components: { ChannelSort },
  mixins: [viewMiXin],
  data() {
    return {
      RADIX_POINT_COMPUTED_MODE_LIST,
      STOCK_WAREHOUSE_TYPE_SON_1_LIST_VIRTUAL: this.$lodash.clone(STOCK_WAREHOUSE_TYPE_SON_1_LIST),
      STOCK_WAREHOUSE_TYPE_SON_1_LIST_STOCK: this.$lodash.clone(STOCK_WAREHOUSE_TYPE_SON_1_LIST),
      backordersChannelPriorityArray: [],
      channelPriorityArray: [],
      form: getDefaultForm(),
      rules: {
        allotOrTransferAudit: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
      },
    };
  },
  watch: {
    STOCK_WAREHOUSE_TYPE_SON_1_LIST_VIRTUAL: {
      handler(v) {
        this.form.virtualReplenishPriorityRule = v.map(e => e.value).join(',');
      },
      deep: true,
      immediate: true,
    },
    STOCK_WAREHOUSE_TYPE_SON_1_LIST_STOCK: {
      handler(v) {
        this.form.stockDeductionPriorityRule = v.map(e => e.value).join(',');
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.refresh();
    this.rowDrop();
  },
  methods: {
    // 行拖拽
    rowDrop() {
      /** ******************        虚仓自动补货优先规则           */
      // 此时找到的元素是要拖拽元素的父容器
      let tbody = document.querySelector('#virtualReplenishPriorityRule');
      const _THIS = this;
      Sortable.create(tbody, {
        //  指定父元素下可被拖拽的子元素
        draggable: '.virtualReplenishPriorityRule',
        handle: '.virtualReplenishPriorityRule-handle',
        onEnd({ newIndex, oldIndex }) {
          const currRow = _THIS.STOCK_WAREHOUSE_TYPE_SON_1_LIST_VIRTUAL.splice(oldIndex, 1)[0];
          _THIS.STOCK_WAREHOUSE_TYPE_SON_1_LIST_VIRTUAL.splice(newIndex, 0, currRow);
        },
      });

      /** *****************        库存类型扣减顺序优先级     */
      // 此时找到的元素是要拖拽元素的父容器
      tbody = document.querySelector('#stockDeductionPriorityRule');
      Sortable.create(tbody, {
        //  指定父元素下可被拖拽的子元素
        draggable: '.stockDeductionPriorityRule',
        handle: '.stockDeductionPriorityRule-handle',
        onEnd({ newIndex, oldIndex }) {
          const currRow = _THIS.STOCK_WAREHOUSE_TYPE_SON_1_LIST_STOCK.splice(oldIndex, 1)[0];
          _THIS.STOCK_WAREHOUSE_TYPE_SON_1_LIST_STOCK.splice(newIndex, 0, currRow);
        },
      });
    },

    blurNumber() {
      const n = Number(Number(this.form.inventoryOversoldRatio || 0).toFixed(2));
      this.form.inventoryOversoldRatio = n;
    },
    refresh() {
      stockApi.detailRules().then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.form = { ...this.form, ...res };

          this.STOCK_WAREHOUSE_TYPE_SON_1_LIST_VIRTUAL.sort((a, b) => {
            return (
              this.form.virtualReplenishPriorityRule.indexOf(a.value) -
              this.form.virtualReplenishPriorityRule.indexOf(b.value)
            );
          });
          this.STOCK_WAREHOUSE_TYPE_SON_1_LIST_STOCK.sort((a, b) => {
            return (
              this.form.stockDeductionPriorityRule.indexOf(a.value) -
              this.form.stockDeductionPriorityRule.indexOf(b.value)
            );
          });

          this.backordersChannelPriorityArray = JSON.parse(
            this.form.backordersChannelPriority || '[]',
          );
          this.channelPriorityArray = JSON.parse(this.form.channelPriority || '[]');
        }
      });
    },
    handleChannelSortConfirm(data, key) {
      this[key] = data;
    },
    /* 关闭弹窗 */
    handleClose() {
      this.tryCancel();
      this.$confirm(this.$t('StockRules.Footer.current'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.$refs.form.resetFields();
          this.refresh();
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('StockRules.Footer.Canceled'),
          });
        });
    },
    handleConfirm() {
      this.$refs.form.validate(valid => {
        if (!valid) return this.$scrollToFormError();
        const API_DATA = this.$lodash.clone(this.form);
        API_DATA['backordersChannelPriority'] = JSON.stringify(this.backordersChannelPriorityArray);
        API_DATA['channelPriority'] = JSON.stringify(this.channelPriorityArray);
        this.updateApi(API_DATA);
      });
    },
    updateApi(API_DATA) {
      stockApi.updateRules(API_DATA).then(res => {
        this.refresh();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.sort-item {
  position: relative;
  display: flex;
  width: 250px;
  padding: 0.5rem 1.25rem;
  margin-bottom: -1px;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.125);
  justify-content: space-between;
  align-items: center;
}
.svg-icon {
  cursor: pointer;
  font-size: 18px;
}
</style>
